<ion-header class="my-account-header">
  <ion-toolbar class="toolbar">
    <ion-buttons slot="start" *ngIf="pageType">
      <ion-button (click)="goBack()">
        <ion-icon name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="pageType">
      <ion-icon [name]="icon" [ngStyle]="{ color: color }"></ion-icon>
      <span>{{ title }}</span>
    </ion-title>
    <ion-buttons slot="end" *ngIf="!pageType">
      <ion-button (click)="goBack()" class="close-button">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
